<template>
  <div></div>
</template>

<script>
export default {
  created () {
    this.$router.replace({name: 'page-not-authorized'})
  }
}
</script>
